import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SetPassword from "@/components/singin/SetPassword";

import {useAuth} from "@/providers/authProvider"
import { updatePasswordViaAPI } from '@/providers/auth';
import { toast } from "react-toastify";
export const Route = createFileRoute('/_layout/_auth/profile/change-password')({
  component:ChangePassword
})


function ChangePassword(){
  const {user} = useAuth()
  const navigate = useNavigate()
  const changePassword = async (password: string) => {
    try{
      if(user){
        await updatePasswordViaAPI(user.uid, password)
      }
    }catch(error){
      toast.success("パスワードを変更でエラーが発生しました。", {
        position: "bottom-left"
      })
      return ""
    }
    toast.success("パスワードを変更しました。", {
      position: "bottom-left"
    })
    navigate({to: "/profile"})
    return ""
  }
  return <SetPassword updatePassword={changePassword} />
}